exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*# sourceMappingURL=src/components/cdu/EventStats.css.map */", "", {"version":3,"sources":["D:/Build/MM2/Main/Web/CTS/Odds Boards/src/components/cdu/EventStats.vue"],"names":[],"mappings":"AAAA,6DAA6D","file":"EventStats.vue","sourcesContent":["/*# sourceMappingURL=src/components/cdu/EventStats.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6b7ede0","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cdu/EventStats.vue
// module id = xHyL
// module chunks = 1